export default "__VITE_ASSET__C0Rl9$XK__"